// extracted by mini-css-extract-plugin
export default {"detectorBlock":"detectorBlock--OSQco"};